import { render, staticRenderFns } from "./HeaderCustom.vue?vue&type=template&id=48331adc&scoped=true&"
var script = {}
import style0 from "./HeaderCustom.vue?vue&type=style&index=0&id=48331adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48331adc",
  null
  
)

export default component.exports